// Required by Axios
import 'es6-promise/auto';
import 'isomorphic-fetch';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { initializeSentry } from 'config/sentry';
import { exposeMomentForIntegrationTests } from 'test/testUtils';
import { initializeDatadog } from 'logging/datadog';

initializeSentry();
exposeMomentForIntegrationTests();
initializeDatadog();

if (process.env.NODE_ENV !== 'production' && process.env.IS_API_MOCKED) {
  const { worker } = require('./bento-ordering/api/mocks/browser');
  worker.start();
}

ReactDOM.render(<App />, document.getElementById('app'));
